
import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData } from '../../../apiService';
import * as XLSX from 'xlsx';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import ReportShell, { RC, dateInp, refreshBtn, excelBtn, thStyle } from './ReportShell';

function StockRawMaterialReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };


    // Raw Material

    const [RawTypeOptions, setRawTypeOptions] = useState([]);
    const [selectedRawType, setSelectedRawType] = useState("");
    const [selectedRaw, setSelectedRaw] = useState("0");

    const fetchRawType = async () => {
        try {

            const response = await fetchData('RawMaterialApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(rwm => ({
                    value: rwm.id,
                    label: rwm.name
                }));
                setRawTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Raw Type:', error);
        }
    };
    const handleRawTypeChange = (selectedOption) => {
        setSelectedRawType(selectedOption);
        setSelectedRaw(selectedOption.value);
    };

    useEffect(() => {
        fetchRawType();
    }, []);


    const fetchTableData = async () => {
        const branchId = 0;
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/StockRawMaterial/${companyId}/${branchId}/${selectedRaw}/${fromDate}/${toDate}/`, token);
            console.log(response); // Log the entire response to debug
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Stock Raw Material Details:', error);
        }


    };


    const hasReadReportPermission = permissions.includes('Read Reports');


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     const headerCaption = [`Stock Raw Material Data`];
    //     excelData.push(headerCaption);
    //     const headerRow = ['Code', 'Name', 'HSNCode', 'GSTRate', 'Opening Qty', 'Purchase Qty', 'Purchase Return Qty', 'Production Qty', 'Closing Qty'];
    //     excelData.push(headerRow);
    //     filteredDataItem.forEach((rowData, index) => {
    //         const dataRow = [];
    //         dataRow.push(rowData.Code, rowData.Name, rowData.HSNCode, rowData.GSTRate, rowData.OpeningQty, rowData.PurchaseQty, rowData.PurchaseReturnQty, rowData.SaleQty, rowData.ClosingQty);
    //         excelData.push(dataRow);
    //     });

    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Stock Raw Material Details');
    //     XLSX.writeFile(wb, 'Stock_Raw_Material_Details.xlsx');
    // };    


    const handleExportExcel = () => {
        const excelData = [];
        const headerCaption = ['Stock Raw Material Data'];
        excelData.push(headerCaption);

        const headerRow = ['Code', 'Name', 'HSNCode', 'GSTRate', 'Opening Qty', 'Purchase Qty', 'Purchase Return Qty', 'Production Qty', 'Closing Qty'];
        excelData.push(headerRow);

        // Initialize totals
        let totalOpeningQty = 0;
        let totalPurchaseQty = 0;
        let totalPurchaseReturnQty = 0;
        let totalSaleQty = 0;
        let totalClosingQty = 0;

        // Data rows
        filteredDataItem.forEach(rowData => {
            const dataRow = [
                rowData.Code,
                rowData.Name,
                rowData.HSNCode,
                rowData.GSTRate,
                rowData.OpeningQty,
                rowData.PurchaseQty,
                rowData.PurchaseReturnQty,
                rowData.SaleQty,
                rowData.ClosingQty
            ];

            // Add to totals
            totalOpeningQty += Number(rowData.OpeningQty || 0);
            totalPurchaseQty += Number(rowData.PurchaseQty || 0);
            totalPurchaseReturnQty += Number(rowData.PurchaseReturnQty || 0);
            totalSaleQty += Number(rowData.SaleQty || 0);
            totalClosingQty += Number(rowData.ClosingQty || 0);

            excelData.push(dataRow);
        });

        // Total row
        const totalRow = [
            'Total', '', '', '', // placeholders for non-numeric columns
            totalOpeningQty,
            totalPurchaseQty,
            totalPurchaseReturnQty,
            totalSaleQty,
            totalClosingQty
        ];
        excelData.push(totalRow);

        // Create sheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Merge title row
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headerRow.length - 1 } },
        ];

        // Column widths
        ws['!cols'] = headerRow.map(() => ({ wch: 20 }));

        // Workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Stock Raw Material Details');
        XLSX.writeFile(wb, 'Stock_Raw_Material_Details.xlsx');
    };


    const cellStyle = {
        borderBottom: '1px solid black',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };





    return (
        <ReportShell
            title="STOCK — RAW MATERIAL"
            recordCount={filteredDataItem.length}
            filters={<>
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px' }}>From</span>
                <input type="date" value={fromDate} onChange={handleFromDateChange} style={{ ...dateInp, width: '130px' }} />
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px', marginLeft: '8px' }}>To</span>
                <input type="date" value={toDate} onChange={handleToDateChange} style={{ ...dateInp, width: '130px' }} />
                <div style={{ minWidth: 200 }}>
                    <Select value={selectedRawType} onChange={handleRawTypeChange} options={RawTypeOptions} placeholder="Raw Material" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }) }} />
                </div>
            </>}
            actions={<>
                <button onClick={fetchTableData} style={refreshBtn}>Refresh</button>
                <button onClick={handleExportExcel} style={excelBtn}>Excel</button>
            </>}
        >
            <TableContainer component={Paper}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {[['Code','left'],['Name','left'],['HSN Code','left'],['GST Rate','right'],['Opening Qty','right'],['Purchase Qty','right'],['Purchase Return Qty','right'],['Production Qty','right'],['Closing Qty','right']].map(([col, align]) => (
                                <TableCell key={col} style={{ ...thStyle, textAlign: align }}>{col}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredDataItem.map((data, index) => (
                            <TableRow key={data.id || index} sx={{
                                backgroundColor: index % 2 === 0 ? '#fdfdfd' : '#f7fdfc',
                                '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' },
                            }}>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.Code}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.Name}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.HSNCode}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.GSTRate}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.OpeningQty}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.PurchaseQty}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.PurchaseReturnQty}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.SaleQty}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.ClosingQty}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: '#f0f4f4' }}>
                            <TableCell colSpan={4} sx={{ fontWeight: 700, padding: '5px 8px', fontSize: '12px' }}>TOTAL</TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{filteredDataItem.reduce((s, i) => s + Number(i.OpeningQty || 0), 0).toFixed(2)}</TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{filteredDataItem.reduce((s, i) => s + Number(i.PurchaseQty || 0), 0).toFixed(2)}</TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{filteredDataItem.reduce((s, i) => s + Number(i.PurchaseReturnQty || 0), 0).toFixed(2)}</TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{filteredDataItem.reduce((s, i) => s + Number(i.SaleQty || 0), 0).toFixed(2)}</TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{filteredDataItem.reduce((s, i) => s + Number(i.ClosingQty || 0), 0).toFixed(2)}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </ReportShell>
    );
}

export default StockRawMaterialReport;
